import React, { FunctionComponent } from "react";
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
  useTheme
} from "@mui/material";
import styles from "./styles.module.scss";
import { Icon, IconType } from "../../icons";

export const SelectListItem: FunctionComponent<ISelectListItemProps> = ({
  iconType,
  title,
  subtitle,
  labels,
  values,
  value,
  handleChange,
  disabled
}) => {
  const theme = useTheme();
  return (
    <ListItem>
      <div className={styles.itemDiv}>
        <ListItemIcon>
          <Icon type={iconType} />
        </ListItemIcon>
        {title && (
          <ListItemText
            disableTypography
            className={styles.title}
            primary={title}
            secondary={
              <Typography
                className={styles.subtitle}
                style={{ color: theme.palette.primary.subtitle }}
              >
                {subtitle}
              </Typography>
            }
          />
        )}
        <Select
          value={value}
          disabled={disabled}
          className={styles.item}
          onChange={handleChange}
          sx={{ height: "30px" }}
        >
          {labels.map((label, index) => (
            <MenuItem key={`item_${index}`} value={values[index]}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </div>
    </ListItem>
  );
};

export interface ISelectListItemProps {
  iconType: IconType;
  title?: string;
  subtitle?: string;
  labels: string[];
  values: any[];
  value: any;
  handleChange: (event: SelectChangeEvent) => void;
  disabled?: boolean;
}
